<template>
    <div>
        <vx-card class="mt-4 profile_block" :title="chapter.label">
            <TableView :use_number="chapter.use_number" :information="information" v-if="chapter.view ==='table'"/>
            <div v-else>
                <div v-if="Array.isArray(information)">
                    <vx-card  v-for="(item, index) in information" :key="index">
                        <ObjectType :information="item"/>
                    </vx-card>
                </div>
                <ObjectType v-else :information="information"/>
            </div>
        </vx-card>
    </div>
</template>

<script>
import axios from '@/configs/Axios'
import ObjectType from "@/pages/Home/ListGlobalComponents/Tabs/components/ObjectType";
import TableView from "@/pages/Home/ListGlobalComponents/Tabs/table/TableView";
export default {
    name: "Chapter",
    data() {
        return {
            information: null,

        }
    },
    components:{
        ObjectType,
        TableView,
    },
    props:{
        chapter:{
            type:Object,
        },
    },
    computed: {
        path() {
            return `${ this.chapter.path }/${ this.chapter.type }/`
        },
        payload(){
            if (this.chapter.payload){
                return this.chapter.payload
            }else{
                return this.$route.query
            }
        },

    },
    methods:{
        async request_data(){
            axios.get(this.path,{params:this.payload})
                .then(async (responce) => {
                    this.information = responce.data
                })
                .catch((error) => { reject(error) })
        }
    },
    async created() {
        await this.request_data()
    },
};
</script>


